module.exports = __webpack_public_path__ + "images/stickers/pete-alert@2x.3453c1a26ddd1187e564.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-alert@2x.png
// module id = xKhn
// module chunks = 13